
import { Options, Vue } from 'vue-class-component'

@Options({
    emits: ['close', 'open'],
    props: {
        flopData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            list: [1,2,3],
            chooseIndex: null,
            openTitle: '打开任意红包<br/>有机会抽到现金红包哦',
            winTitle: '恭喜您，抽到现金红包',
            failTitle: '亲，很遗憾未抽中现金红包哦',
        }
    },
    mounted(){
        if(this.flopData.pid) this.chooseIndex = 1
    },
    methods: {
        closeClick() {
            this.$emit('close')
        },
        chooseClick(index: Number) {
            if(this.flopData.state == 2) return false
            this.chooseIndex = index;
            this.$emit('open')
        },
    }
})
export default class FlopModal extends Vue { }
